import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface OnboardingStatus {
  emailVerified: boolean;
  termsAccepted: boolean;
  profileComplete: boolean;
  activatedAt: string | null;
  accountStatus: 'new' | 'free' | 'standard' | 'pro' | 'admin';
  trialEndsAt?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private http = inject(HttpClient);
  private apiUrl = environment.api_host;

  /**
   * Get the current user's onboarding status
   */
  getOnboardingStatus(): Observable<OnboardingStatus> {
    return this.http.get<OnboardingStatus>(`${this.apiUrl}/me/onboarding-status`);
  }

  /**
   * Resend verification email to the authenticated user
   */
  resendVerificationEmail(): Observable<any> {
    return this.http.post(`${this.apiUrl}/me/resend-verification-email`, {});
  }

  /**
   * Accept Terms of Service and Privacy Policy
   */
  acceptTerms(termsVersion: string, privacyVersion: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/me/accept-terms`, {
      termsVersion,
      privacyVersion
    });
  }
}
